/* SIGMA · Constructor 3X2 de la ficha.
   Arma el carrito con tres jerseys. El descuento lo aplica la promocion de la tienda:
   aqui solo se muestra el ahorro estimado, para no contradecir al checkout. */
(function () {
  if (window.__sigBundle) return;
  window.__sigBundle = true;

  var raiz = document.querySelector('[data-sig-bundle]');
  var picker = document.getElementById('SigPicker');
  if (!raiz || !picker) return;

  // la ventana se saca de la columna: dentro de ella quedaba angosta y pegada a un lado
  if (picker.parentElement !== document.body) document.body.appendChild(picker);

  var slots = [null, null, null];              // 0 = este producto, 1 y 2 elegidos
  var POR_PAGINA = 20;                          // cuántos jerseys por página
  var estado = { tab: null, pagina: 1 };        // pestaña activa y página, para "ver más"
  var slotActivo = 1;
  /* Cuántos jerseys hay YA en el carrito. El constructor pedía siempre dos más,
     como si el carrito estuviera vacío: con 2 dentro te llevaba a 5 cuando con
     UNO ya cerrabas el trío. Ahora solo pide lo que de verdad falta. */
  var enCarrito = 0;
  /* Los jerseys que YA están en el carrito se montan solos en las columnas.
     Antes el constructor los ignoraba: con 2 dentro te pedía 2 más y no
     entendías por qué, si el carrito de al lado decía que faltaba 1. */
  var deCarrito = [];

  /* La columna que cuenta: lo que el cliente eligió aquí manda; si no eligió,
     lo que ya trae del carrito. Un solo lugar donde se resuelve, para que el
     pintado, el cálculo del gratis y el botón no puedan discrepar. */
  function efectivo(i) { return slots[i] || deCarrito[i - 1] || null; }

  function slotsDesdeCarrito(c) {
    /* Solo se precargan los jerseys SUELTOS, los que no alcanzan a formar un
       trío cerrado. Con 3 en el carrito ya hay un trío completo con su gratis:
       precargar dos de ellos hacía parecer que formaban parte de un trío nuevo
       y el botón ofrecía "agregar los 3" cuando solo iba a agregar uno.

       El resto (los que ya cerraron trío) se cuentan en el mensaje, no se
       pintan: su regalo ya está dado.

       Se toman los ÚLTIMOS del carrito, que son los que el cliente acaba de
       agregar y tiene en la cabeza. */
    var sueltos = (c.item_count || 0) % 3;
    if (!sueltos) return [];

    var unidades = [];
    (c.items || []).forEach(function (it) {
      for (var u = 0; u < it.quantity; u++) unidades.push(it);
    });
    var out = [];
    unidades.slice(-sueltos).forEach(function (it) {
      for (var q = 0; q < 1 && out.length < 2; q++) {
        out.push({
          id: it.variant_id,
          clave: it.key,                   // para poder quitarlo del carrito
          cantidad: it.quantity,
          handle: it.handle,               // para poder traer sus tallas
          tallas: null,                    // se rellenan aparte
          img: it.image ? it.image.replace(/(\.\w+)(\?|$)/, '_200x200$1$2') : '',
          title: it.product_title,
          price: it.price,
          variante: it.variant_title || '',
          personalizado: (function () {
            var p = it.properties || {};
            var t = ((p['Nombre'] || '') + ' ' + (p['Número'] || '')).trim();
            return t || '';
          })(),
          fijo: true                       // viene del carrito: se edita allá
        });
      }
    });
    return out;
  }

  var cacheTabs = {};
  var MXN = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });

  var elMsg = raiz.querySelector('[data-sig-bundle-msg]');
  var elCta = raiz.querySelector('[data-sig-bundle-add]');
  var elAhorro = raiz.querySelector('[data-sig-bundle-ahorro]');
  var lista = picker.querySelector('[data-sig-picker-list]');
  var tabs = picker.querySelector('[data-sig-picker-tabs]');
  var input = picker.querySelector('[data-sig-picker-input]');

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Mismo criterio de nombres que las tarjetas, la ficha y el carrito:
     quita coletillas, corrige abreviaturas y deja el jugador como complemento. */
  function limpia(t) {
    t = t || '';
    (raiz.dataset.strip || '').split(';').forEach(function (b) {
      b = b.trim(); if (b) t = t.split(b).join('');
    });
    (raiz.dataset.rename || '').split('\n').forEach(function (l) {
      var kv = l.split('='); if (kv.length === 2) t = t.split(kv[0].trim()).join(kv[1].trim());
    });
    t = t.replace(/\s{2,}/g, ' ').trim();
    var i = t.indexOf(' - ');
    if (i > -1) return t.slice(0, i).trim() + ' · ' + t.slice(i + 3).trim();
    var c = t.indexOf(',');
    if (c > -1 && t.slice(0, c).indexOf('#') > -1) return t.slice(c + 1).trim() + ' · ' + t.slice(0, c).trim();
    return t;
  }
  /* Shopify devuelve el precio distinto segun el endpoint:
     /products/x.js -> numero en centavos | products.json y suggest.json -> texto en pesos.
     Sin esto un jersey de $949 se mostraba como $9. */
  function aCentavos(v) {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    var n = parseFloat(String(v).replace(/[^\d.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  function precio(v) { return MXN.format(aCentavos(v) / 100); }

  /* ---------- la ventana ---------- */
  function abrir(slot) {
    slotActivo = slot;
    picker.hidden = false;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('sig-capa-abierta');
    if (!tabs.children.length) construirTabs();
    else tabs.querySelector('button').click();
    setTimeout(function () { input.focus(); }, 60);
  }
  function cerrar() { picker.hidden = true; document.body.style.overflow = '';
    document.body.classList.remove('sig-capa-abierta'); }

  function construirTabs() {
    var club = raiz.dataset.club;
    var opciones = [];
    /* Las dos primeras pestañas no tenían imagen y por eso desentonaban contra
       las ligas, que sí la traen. Ahora llevan marca: el escudo real del club
       si la colección tiene imagen, y un icono si no. */
    /* Se toman del marcado, donde Liquid ya los pintó con el mismo snippet de
       iconos que usa el resto de la tienda. Escribirlos a mano aquí los dejaba
       fuera del sistema y se dibujaban mal. */
    function icoDelTema(clave) {
      /* Se busca en el DOCUMENTO, no dentro de raiz: el contenedor de iconos
         que pinta Liquid es HERMANO del bloque, no hijo. Buscándolo dentro no
         lo encontraba y las pestañas se quedaban sin marca. */
      var n = document.querySelector('[data-sig-iconos] [data-ico="' + clave + '"]');
      return n ? n.innerHTML : '';
    }
    var ESC_CLUB = icoDelTema('club');
    var ESC_RECO = icoDelTema('reco');
    if (club) {
      opciones.push({
        id: 'club',
        txt: 'Más de ' + (raiz.dataset.clubTitulo || 'este equipo'),
        img: raiz.dataset.clubImg || '',
        ico: ESC_CLUB
      });
    }
    opciones.push({ id: 'reco', txt: 'Recomendados', ico: ESC_RECO });
    // ligas y selecciones que se configuran en el editor: "handle = Nombre"
    // ligas, clubes y selecciones: vienen resueltos desde Liquid, con su imagen
    var nodo = document.getElementById('SigBundleFiltros');
    if (nodo) {
      try {
        JSON.parse(nodo.textContent).forEach(function (f) {
          if (f.sep) { opciones.push({ sep: f.sep }); return; }
          opciones.push({ id: 'col:' + f.h, txt: f.txt, img: f.img });
        });
      } catch (e) {}
    }
    tabs.innerHTML = opciones.map(function (o, i) {
      if (o.sep) return '<span class="sig-picker__sep">' + esc(o.sep) + '</span>';
      var img = o.img
        ? '<img src="' + esc(o.img) + '" alt="" loading="lazy">'
        : (o.ico ? '<span class="sig-picker__ico">' + o.ico + '</span>' : '');
      return '<button type="button" data-tab="' + o.id + '"' + (i === 0 ? ' aria-selected="true"' : '') + '>' + img + '<span>' + esc(o.txt) + '</span></button>';
    }).join('');
    tabs.querySelector('button').click();
  }

  function pintar(prods, opciones) {
    opciones = opciones || {};
    var viejo = lista.querySelector('[data-sig-mas]');
    if (viejo) viejo.remove();
    if (!prods.length && !opciones.anadir) {
      lista.innerHTML = '<p class="sig-picker__vacio">No encontramos jerseys para mostrar aquí.</p>';
      return;
    }
    var html = prods.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || p.image || '';
      if (img && typeof img === 'object') img = img.src || img.url || '';
      return '<article class="sig-pick" data-handle="' + esc(p.handle) + '">' +
        '<span class="sig-pick__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="sig-pick__name">' + esc(limpia(p.title)) + '</span>' +
        '<span class="sig-pick__price">' + precio(p.price != null ? p.price : (p.variants && p.variants[0] && p.variants[0].price)) + '</span>' +
        '<button type="button" class="sig-pick__btn" data-elegir>Elegir</button>' +
      '</article>';
    }).join('');

    if (opciones.anadir) lista.insertAdjacentHTML('beforeend', html);
    else lista.innerHTML = html;

    if (opciones.hayMas) {
      lista.insertAdjacentHTML('beforeend',
        '<button type="button" class="sig-picker__mas" data-sig-mas>Ver más jerseys</button>');
    }
  }

  var ultimoError = '';
  /* Diagnóstico: sirvió para depurar el buscador del constructor, pero no tiene
     por qué verlo un cliente. Solo aparece si se abre la página con ?sigdebug=1 */
  var DEPURAR = /[?&]sigdebug=1/.test(location.search);
  function diag(txt) {
    if (!DEPURAR) return;
    var d = picker.querySelector('[data-sig-diag]');
    if (!d) {
      d = document.createElement('p');
      d.setAttribute('data-sig-diag', '');
      d.className = 'sig-picker__diag';
      picker.querySelector('.sig-picker__panel').appendChild(d);
    }
    d.textContent = txt;
  }
  /* Se pide con XMLHttpRequest y con tiempo límite. Varias apps de la tienda
     reemplazan window.fetch (el mini carrito, RMPB, Flashy); si una de esas
     envolturas falla, la petición se queda colgada para siempre y la ventana
     aparece vacía sin decir nada. Con XHR no dependemos de ellas. */
  function traer(url) {
    return new Promise(function (resolve) {
      var x = new XMLHttpRequest();
      var cerrado = false;
      var reloj = setTimeout(function () {
        if (cerrado) return;
        cerrado = true;
        ultimoError = 'Sin respuesta en 8 s de ' + url;
        try { x.abort(); } catch (e) {}
        resolve(null);
      }, 8000);
      x.open('GET', url, true);
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        if (cerrado) return;
        cerrado = true; clearTimeout(reloj);
        if (x.status < 200 || x.status >= 300) {
          ultimoError = 'El servidor respondió ' + x.status + ' en ' + url;
          return resolve(null);
        }
        try { resolve(JSON.parse(x.responseText)); }
        catch (e) { ultimoError = 'Respuesta ilegible de ' + url; resolve(null); }
      };
      x.onerror = function () {
        if (cerrado) return;
        cerrado = true; clearTimeout(reloj);
        ultimoError = 'Falló la conexión con ' + url;
        resolve(null);
      };
      x.send();
    });
  }

  tabs.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-tab]');
    if (!b) return;
    tabs.querySelectorAll('button').forEach(function (x) { x.removeAttribute('aria-selected'); });
    b.setAttribute('aria-selected', 'true');
    estado.tab = b.dataset.tab;
    estado.pagina = 1;
    lista.innerHTML = '<p class="sig-picker__vacio">Cargando…</p>';
    try { cargarPagina(false); }
    catch (err) {
      lista.innerHTML = '<p class="sig-picker__vacio">Falló al abrir la pestaña.<br><small>' +
        esc(err && err.message ? err.message : String(err)) + '</small></p>';
    }
  });

  function urlDeTab(tab, pagina) {
    if (tab === 'club') return '/collections/' + raiz.dataset.club + '/products.json?limit=' + POR_PAGINA + '&page=' + pagina;
    if (tab.indexOf('col:') === 0) return '/collections/' + tab.slice(4) + '/products.json?limit=' + POR_PAGINA + '&page=' + pagina;
    return '/recommendations/products.json?product_id=' + raiz.dataset.productId + '&limit=12';
  }

  /* Trae una página de la pestaña activa. Recomendados no pagina, así que ahí no
     aparece el botón. En colecciones, el botón sale mientras la página venga llena. */
  function cargarPagina(anadir) {
    var tab = estado.tab;
    var esColeccion = tab === 'club' || tab.indexOf('col:') === 0;
    var url = urlDeTab(tab, estado.pagina);
    diag('pestaña: ' + tab + ' · pidiendo: ' + url);
    traer(url).then(function (d) {
      diag('pestaña: ' + tab + ' · ' + (ultimoError || ('respondió con ' + (d && d.products ? d.products.length : 0) + ' productos')));
      try {
        var ps = (d && (d.products || (d.resources && d.resources.results && d.resources.results.products))) || [];
        ps = ps.filter(function (p) { return String(p.id) !== String(raiz.dataset.productId); });
        if (!ps.length && !anadir) {
          lista.innerHTML = '<p class="sig-picker__vacio">Sin resultados en esta pestaña.<br><small>' +
            esc(ultimoError || ('Respuesta vacía de ' + url)) + '</small></p>';
          return;
        }
        pintar(ps, { anadir: anadir, hayMas: esColeccion && ps.length >= POR_PAGINA - 1 });
      } catch (err) {
        lista.innerHTML = '<p class="sig-picker__vacio">Error al dibujar la lista.<br><small>' +
          esc(err && err.message ? err.message : String(err)) + '</small></p>';
      }
    });
  }

  lista.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sig-mas]');
    if (!b) return;
    b.textContent = 'Cargando…';
    estado.pagina += 1;
    cargarPagina(true);
  });

  var t;
  input.addEventListener('input', function () {
    clearTimeout(t);
    var q = input.value.trim();
    if (q.length < 2) { tabs.querySelector('[aria-selected]')?.click(); return; }
    t = setTimeout(function () { buscar(q); }, 220);
  });

  function mapearSugeridos(d) {
    var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
    return ps.map(function (p) {
      var partes = (p.url || '').split('/products/');
      return {
        id: p.id,
        handle: partes[1] ? partes[1].split('?')[0] : '',
        title: p.title,
        price: p.price,
        featured_image: p.image
      };
    });
  }

  /* Busca igual que el buscador del menú: si no hay resultados, corrige el error de
     dedo con la MISMA lógica (alias + distancia de edición) y avisa que corrigió.
     La lógica vive en sigma-search.js y se expone como window.SigmaSearch. */
  function buscar(q) {
    lista.innerHTML = '<p class="sig-picker__vacio">Buscando…</p>';
    var url = function (x) {
      return '/search/suggest.json?q=' + encodeURIComponent(x) + '&resources[type]=product&resources[limit]=10';
    };
    traer(url(q)).then(function (d) {
      var ps = mapearSugeridos(d);
      if (ps.length) { pintar(ps, { hayMas: false }); return; }
      var corregido = (window.SigmaSearch && window.SigmaSearch.corregir) ? window.SigmaSearch.corregir(q) : null;
      if (!corregido) { pintar([], { hayMas: false }); return; }
      traer(url(corregido)).then(function (d2) {
        var ps2 = mapearSugeridos(d2);
        if (!ps2.length) { pintar([], { hayMas: false }); return; }
        pintar(ps2, { hayMas: false });
        var aviso = document.createElement('p');
        aviso.className = 'sig-picker__aviso';
        aviso.innerHTML = 'Mostrando resultados para <b>' + esc(corregido) + '</b>';
        lista.prepend(aviso);
      });
    });
  }

  /* ---------- elegir talla y llenar la casilla ---------- */
  lista.addEventListener('click', function (e) {
    var card = e.target.closest('.sig-pick');
    if (!card || !e.target.closest('[data-elegir]')) return;
    var btn = e.target.closest('[data-elegir]');
    btn.textContent = 'Cargando…';
    traer('/products/' + card.dataset.handle + '.js').then(function (p) {
      btn.textContent = 'Elegir';
      if (!p) return;
      var disp = (p.variants || []).filter(function (v) { return v.available; });
      if (!disp.length) { btn.textContent = 'Agotado'; return; }
      // una entrada por talla: con Talla/Versión/Parche la misma talla se repite
      var vistas = {}, tallas = [];
      disp.forEach(function (v) {
        var etiqueta = (v.title || '').split('/')[0].split('(')[0].trim() || 'Única';
        if (vistas[etiqueta]) return;
        vistas[etiqueta] = true;
        tallas.push({ id: v.id, etiqueta: etiqueta, price: v.price });
      });
      slots[slotActivo] = {
        handle: card.dataset.handle,
        title: limpia(p.title),
        img: p.featured_image || '',
        tallas: tallas,
        id: tallas[0].id,
        size: tallas[0].etiqueta,
        price: tallas[0].price,
        personalizacion: null
      };
      refrescar();
      cerrar();
    });
  });

  /* ---------- estado del constructor ---------- */
  function refrescar() {
    // el precio de la primera columna se pinta con el mismo formato que los otros dos:
    // venia de Liquid como "$ 1,049.00" y los demas como "$999"
    var elPrecio0 = raiz.querySelector('[data-sig-precio-actual]');
    if (elPrecio0) {
      var actual = precioActual();
      if (actual > 0) elPrecio0.innerHTML = '<b>' + precio(actual) + '</b>';
    }
    /* Las tres columnas SIEMPRE están. Intenté esconderlas según el carrito y
       fue peor: el bloque cambiaba de forma en cada visita y llegaba a decir
       "ya llevas 3" con una sola columna y el botón pidiendo dos más. El
       constructor arma UN TRÍO; eso no cambia. Lo que cambia es el mensaje,
       que ahora sí reconoce lo que ya hay en el carrito. */
    [1, 2].forEach(function (i) {
      var el = raiz.querySelector('[data-slot="' + i + '"]');
      el.hidden = false;
      var d = efectivo(i);
      if (!d) {
        el.className = 'sig-bundle__slot is-empty';
        el.innerHTML =
          '<button type="button" class="sig-slot__vacia" data-slot="' + i + '" data-sig-bundle-pick>' +
            '<span class="sig-bundle__plus" aria-hidden="true">+</span>' +
            '<span class="sig-slot__rotulo">Elegir jersey</span>' +
          '</button>';
        return;
      }
      /* ANTES de tocar d.tallas: las columnas que vienen del carrito no las
         traen, y leerlas aquí reventaba el pintado entero con
         "Cannot read properties of undefined (reading 'map')".
         Ya está en el carrito: aquí solo se muestra. Cambiar talla o
         personalizar se hace en el carrito, no en dos lugares distintos. */
      if (d.fijo) {
        /* MISMA estructura que las demás columnas —foto, precio, rótulo,
           campo de talla y renglón de personalización— aunque aquí no se
           puedan tocar. Si una columna tiene menos elementos que las otras,
           los renglones se desalinean y "TALLA" queda a la altura del valor
           de al lado. La rejilla se alinea por posición, no por contenido. */
        var tallaTxt = (d.variante || '').split('/')[0].split('(')[0].trim() || '—';
        var persTxt = d.personalizado ? esc(d.personalizado) : 'Sin personalizar';
        el.className = 'sig-bundle__slot is-filled is-carrito';
        el.innerHTML =
          '<span class="sig-slot__foto">' +
            (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.title) + '" title="' + esc(d.title) + '" loading="lazy">' : '') +
            '<span class="sig-slot__yaesta">En tu carrito</span>' +
          '</span>' +
          /* Aquí la X saca el jersey DEL CARRITO, no solo de esta vista. Es lo
             que espera quien la pulsa, y el carrito se actualiza al instante. */
          '<button type="button" class="sig-slot__quitar" data-quitar-carrito="' + esc(d.clave) + '" aria-label="Quitar del carrito">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>' +
          '</button>' +
          '<span class="sig-slot__precio"><b>' + precio(d.price) + '</b></span>' +
          '<span class="sig-slot__este">&nbsp;</span>' +
          '<span class="sig-slot__tam">Talla</span>' +
          /* Se puede cambiar la talla de algo que ya está en el carrito. El
             principio de "un solo control por acción" ya lo rompimos con la X
             que saca del carrito, y funciona: el constructor relee el carrito y
             todo se repinta. Mientras no lleguen las tallas se muestra fija. */
          (d.tallas && d.tallas.length
            ? '<select class="sig-slot__talla" data-talla-carrito="' + esc(d.clave) + '" aria-label="Cambiar talla">' +
                d.tallas.map(function (t) {
                  return '<option value="' + t.id + '"' + (String(t.id) === String(d.id) ? ' selected' : '') + '>' + esc(t.etiqueta) + '</option>';
                }).join('') +
              '</select>'
            : '<span class="sig-slot__talla sig-slot__talla--fija">' + esc(tallaTxt) + '</span>') +
          '<button type="button" class="sig-slot__pers sig-slot__pers--fija" data-abrir-carrito>' + persTxt + '</button>';
        return;
      }

      var opciones = (d.tallas || []).map(function (t) {
        return '<option value="' + t.id + '"' + (String(t.id) === String(d.id) ? ' selected' : '') + '>' + esc(t.etiqueta) + '</option>';
      }).join('');
      var pers = d.personalizacion && (d.personalizacion.nombre || d.personalizacion.numero)
        ? esc(((d.personalizacion.nombre || '') + ' ' + (d.personalizacion.numero || '')).trim())
        : 'Personalizar';
      el.className = 'sig-bundle__slot is-filled';
      // sin el nombre del producto: la referencia no lo muestra y asi nunca se corta
      el.innerHTML =
        '<span class="sig-slot__foto">' +
          (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.title) + '" title="' + esc(d.title) + '" loading="lazy">' : '') +
          '<button type="button" class="sig-slot__cambiar" data-cambiar="' + i + '" aria-label="Cambiar jersey">&#8635;</button>' +
        '</span>' +
        /* La X va FUERA del marco de la foto, montada en la esquina. Dentro
           competía con el botón de cambiar y con la etiqueta de "Gratis": tres
           cosas encima de una foto de 110px, y siempre tapando el jersey.
           Fuera del marco no tapa nada y se lee sobre cualquier imagen. */
        '<button type="button" class="sig-slot__quitar" data-quitar="' + i + '" aria-label="Quitar del kit">' +
          /* SVG y no el carácter "×": el glifo trae su propia métrica y queda
             siempre alto dentro del círculo. Un trazo se centra por su viewBox. */
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>' +
        '</button>' +
        '<span class="sig-slot__precio"><b>' + precio(d.price) + '</b></span>' +
        '<span class="sig-slot__este">&nbsp;</span>' +
        '<span class="sig-slot__tam">Talla</span>' +
        '<select class="sig-slot__talla" data-talla="' + i + '" aria-label="Talla">' + opciones + '</select>' +
        '<button type="button" class="sig-slot__pers" data-pers="' + i + '">' + pers + '</button>';
    });

    /* En un 3X2 lo que se regala es el jersey MÁS BARATO de los tres.
       Se marca esa columna en vez de mostrar un porcentaje abstracto. */
    raiz.querySelectorAll('.sig-slot__gratis').forEach(function (n) { n.remove(); });
    raiz.querySelectorAll('.sig-bundle__slot').forEach(function (n) { n.classList.remove('is-free'); });

    var faltan = [1, 2].filter(function (i) { return !slots[i] && !deCarrito[i - 1]; }).length;
    if (!faltan) {
      /* Lee la columna EFECTIVA: la elegida aquí o la que vino del carrito.
         Leyendo solo slots[] daba TypeError en cuanto una columna venía del
         carrito, y el fallo ocurría después de pintar: las columnas se veían
         bien y en silencio se perdían la marca de "Gratis", el texto del botón
         y el ahorro. Un error que no se ve es peor que uno que se ve. */
      var lista3 = [
        { i: 0, p: precioActual() },
        { i: 1, p: (efectivo(1) || {}).price || 0 },
        { i: 2, p: (efectivo(2) || {}).price || 0 }
      ].filter(function (x) { return x.p > 0; });
      if (lista3.length === 3) {
        var barato = lista3.reduce(function (a, b) { return b.p < a.p ? b : a; });
        var col = raiz.querySelector('[data-slot="' + barato.i + '"]');
        var foto = col && col.querySelector('.sig-slot__foto');
        if (foto) {
          col.classList.add('is-free');
          var et = document.createElement('span');
          et.className = 'sig-slot__gratis';
          et.textContent = 'Gratis';
          // Va colgado de la COLUMNA, no de la foto: la foto recorta lo que se
          // sale (overflow:hidden) y la etiqueta tiene que montarse sobre su
          // borde superior, mitad afuera y mitad adentro.
          col.appendChild(et);
        }
      }
    }
    elCta.disabled = faltan > 0;
    /* El mensaje dice el RESULTADO, no la mecánica: cuántos gratis se lleva si
       agrega estos tres. Sumar el carrito evita la contradicción de antes, en
       que el carrito decía "falta 1" y aquí seguía pidiendo dos. */
    var totalDespues = enCarrito + 3;
    var gratisDespues = Math.floor(totalDespues / 3);
    var gratisAhora = Math.floor(enCarrito / 3);
    var nuevos = gratisDespues - gratisAhora;

    if (faltan > 0) {
      elCta.textContent = 'Elige ' + faltan + ' jersey' + (faltan > 1 ? 's' : '') + ' más';
      elMsg.textContent = enCarrito > 0
        ? ('Ya llevas ' + enCarrito + ' en el carrito. Completa este trío y sumas '
           + nuevos + ' jersey' + (nuevos > 1 ? 's' : '') + ' gratis.')
        : 'Elige 2 jerseys más y el tercero va gratis.';
    } else {
      /* El botón dice cuántos va a agregar DE VERDAD. Las columnas que vienen
         del carrito ya están dentro; decir "los 3" cuando solo agrega uno es
         una promesa que el propio carrito desmiente al segundo siguiente. */
      var porAgregar = 1 + [1, 2].filter(function (i) { return slots[i]; }).length;
      elCta.textContent = porAgregar === 3
        ? 'Agregar los 3 al carrito'
        : ('Agregar ' + porAgregar + (porAgregar === 1 ? ' al carrito' : ' al carrito'));
      elMsg.textContent = nuevos > 1
        ? ('Listo: te llevas ' + nuevos + ' jerseys gratis.')
        : 'Listo: el jersey más barato va gratis.';
    }
    if (!faltan) {
      var precios = [precioActual()].concat([1, 2].map(function (i) { return slots[i].price; })).filter(function (n) { return n > 0; });
      var min = Math.min.apply(null, precios);
      elAhorro.hidden = false;
      elAhorro.textContent = 'El jersey más barato va gratis: te ahorras ' + precio(min) + ', se descuenta en el pago.';
    } else { elAhorro.hidden = true; }
  }

  /* cambiar talla, cambiar jersey y personalizar, dentro de la casilla */
  raiz.addEventListener('change', function (e) {
    var espejo = e.target.closest('[data-sig-espejo-talla]');
    if (espejo) {
      // marca el control real de la ficha, no crea otra fuente de verdad
      var real = document.querySelector('.product-form__input--pill input[value="' + CSS.escape(espejo.value) + '"]');
      if (real && !real.disabled) real.click();
      return;
    }
    var sel = e.target.closest('[data-talla]');
    if (!sel) return;
    var i = parseInt(sel.dataset.talla, 10);
    var t = slots[i].tallas.filter(function (x) { return String(x.id) === sel.value; })[0];
    if (t) { slots[i].id = t.id; slots[i].size = t.etiqueta; slots[i].price = t.price; refrescar(); }
  });

  /* Cambiar la talla de una línea que ya está en el carrito.

     Shopify NO permite intercambiar la variante de una línea, así que hay que
     agregar la nueva y quitar la vieja. El orden importa: primero se AGREGA.
     Si fallara el segundo paso el cliente se queda con las dos tallas, que es
     molesto pero recuperable; al revés se quedaría sin ninguna. */
  raiz.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-talla-carrito]');
    if (!sel) return;
    var clave = sel.dataset.tallaCarrito;
    var nuevoId = parseInt(sel.value, 10);
    var col = deCarrito.filter(function (x) { return x.clave === clave; })[0];
    if (!col || !nuevoId || nuevoId === col.id) return;

    sel.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: nuevoId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: clave, quantity: Math.max(0, (col.cantidad || 1) - 1) })
        }).then(function (r) { return r.json(); });
      })
      .then(function (c) {
        leerCarrito(c);
        try { document.dispatchEvent(new CustomEvent('sigma:carrito', { detail: c })); } catch (err) {}
      })
      .catch(function () {
        sel.disabled = false;
        sel.value = col.id;               // se devuelve a la talla real
      });
  });

  raiz.addEventListener('click', function (e) {
    var qc = e.target.closest('[data-quitar-carrito]');
    if (qc) {
      e.stopPropagation();
      var clave = qc.dataset.quitarCarrito;
      var col = deCarrito.filter(function (x) { return x.clave === clave; })[0];
      /* Se baja UNA unidad, no la línea entera: si llevaba dos del mismo jersey,
         quitar una columna no puede llevarse las dos. */
      var nueva = col ? Math.max(0, (col.cantidad || 1) - 1) : 0;
      qc.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: clave, quantity: nueva })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          leerCarrito(c);
          // el carrito de al lado también tiene que enterarse
          try { document.dispatchEvent(new CustomEvent('sigma:carrito', { detail: c })); } catch (err) {}
        })
        .catch(function () { qc.disabled = false; });
      return;
    }

    var q = e.target.closest('[data-quitar]');
    if (q) {
      e.stopPropagation();
      var iq = parseInt(q.dataset.quitar, 10);
      slots[iq] = null;
      /* Si esa columna venía del carrito, al vaciarla vuelve a mostrarse la del
         carrito. Correcto: quitar del kit no es quitar del carrito. */
      refrescar();
      return;
    }
    var c = e.target.closest('[data-cambiar]');
    if (c) { e.stopPropagation(); abrir(parseInt(c.dataset.cambiar, 10)); return; }
    if (e.target.closest('[data-sig-ir-personalizar]')) {
      // la personalizacion de ESTE jersey la maneja la app en la ficha: se lleva alli
      var campo = document.querySelector('.gpo-group');
      if (campo) {
        campo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        campo.classList.add('sig-resalta');
        setTimeout(function () { campo.classList.remove('sig-resalta'); }, 1600);
      }
      return;
    }
    var pz = e.target.closest('[data-pers]');
    if (pz) { e.stopPropagation(); abrirPersonalizar(parseInt(pz.dataset.pers, 10)); }
  });

  /* ---------- personalización por jersey ---------- */
  function abrirPersonalizar(i) {
    var d = slots[i];
    if (!d) return;
    var caja = document.getElementById('SigPers') || (function () {
      var n = document.createElement('div');
      n.id = 'SigPers';
      n.className = 'sig-pers';
      n.hidden = true;
      document.body.appendChild(n);
      return n;
    })();
    var p = d.personalizacion || { nombre: '', numero: '' };
    caja.innerHTML =
      '<div class="sig-pers__panel" role="dialog" aria-modal="true" aria-label="Personalizar">' +
        '<div class="sig-pers__head"><h2>Personaliza este jersey</h2>' +
          '<button type="button" class="sig-pers__x" data-cerrar aria-label="Cerrar">&times;</button></div>' +
        '<p class="sig-pers__sub">' + esc(d.title) + '</p>' +
        '<div class="sig-pers__campos">' +
          '<label>Nombre en la espalda<input type="text" maxlength="12" value="' + esc(p.nombre) + '" data-nombre placeholder="Ej. RODRÍGUEZ"></label>' +
          '<label>Número<input type="text" maxlength="2" inputmode="numeric" value="' + esc(p.numero) + '" data-numero placeholder="10"></label>' +
        '</div>' +
        '<p class="sig-pers__nota" data-nota></p>' +
        '<div class="sig-pers__pie">' +
          '<button type="button" class="sig-pers__quitar" data-quitar>Sin personalizar</button>' +
          '<button type="button" class="sig-pers__ok" data-guardar>Guardar</button>' +
        '</div>' +
      '</div>';
    var nota = caja.querySelector('[data-nota]');
    if (raiz.dataset.persNota) nota.textContent = raiz.dataset.persNota;
    caja.hidden = false;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('sig-capa-abierta');

    caja.onclick = function (e) {
      if (e.target === caja || e.target.closest('[data-cerrar]')) { cerrarPers(caja); return; }
      if (e.target.closest('[data-quitar]')) { slots[i].personalizacion = null; refrescar(); cerrarPers(caja); return; }
      if (e.target.closest('[data-guardar]')) {
        var n = caja.querySelector('[data-nombre]').value.trim().toUpperCase();
        var num = caja.querySelector('[data-numero]').value.replace(/\D/g, '').slice(0, 2);
        slots[i].personalizacion = (n || num) ? { nombre: n, numero: num } : null;
        refrescar();
        cerrarPers(caja);
      }
    };
  }
  function cerrarPers(caja) { caja.hidden = true; document.body.style.overflow = '';
    document.body.classList.remove('sig-capa-abierta'); }

  function precioActual() {
    var el = document.querySelector('product-info .price-item--sale, product-info .price-item--regular, .product__info-container .price-item--regular');
    if (!el) return 0;
    var n = (el.textContent || '').replace(/[^\d]/g, '');
    return n ? parseInt(n, 10) : 0;
  }

  function variantePrincipal() {
    var f = document.querySelector('product-info form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
    return f ? f.value : null;
  }

  raiz.addEventListener('click', function (e) {
    var p = e.target.closest('[data-sig-bundle-pick]');
    if (p) { abrir(parseInt(p.dataset.slot, 10)); return; }
  });
  picker.addEventListener('click', function (e) {
    if (e.target === picker || e.target.closest('[data-sig-picker-close]')) cerrar();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !picker.hidden) cerrar(); });

  elCta.addEventListener('click', function () {
    var principal = variantePrincipal();
    if (!principal) return;
    /* Solo se agrega lo que el cliente eligió AQUÍ. Las columnas que vienen del
       carrito ya están dentro: volver a mandarlas duplicaría el pedido. */
    var items = [{ id: parseInt(principal, 10), quantity: 1 }].concat([1, 2].filter(function (i) {
      return slots[i];
    }).map(function (i) {
      var it = { id: parseInt(slots[i].id, 10), quantity: 1 };
      var pz = slots[i].personalizacion;
      if (pz && (pz.nombre || pz.numero)) {
        it.properties = {};
        if (pz.nombre) it.properties['Nombre'] = pz.nombre;
        if (pz.numero) it.properties['Número'] = pz.numero;
      }
      return it;
    }));
    elCta.disabled = true;
    elCta.textContent = 'Agregando…';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () {
        elCta.textContent = 'Agregado';
        /* Se sueltan las columnas elegidas: ya están en el carrito y de ahí en
           adelante las representa deCarrito. Si se quedan tomadas, lo elegido
           pisa a lo del carrito para siempre y el bloque deja de reaccionar:
           quitabas algo del carrito o agregabas desde recomendados y aquí no
           pasaba nada. */
        slots[1] = null;
        slots[2] = null;
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            leerCarrito(c);
            try { document.dispatchEvent(new CustomEvent('sigma:carrito', { detail: c })); } catch (e) {}
          })
          .catch(function () { setTimeout(refrescar, 1200); });
      })
      .catch(function () { elCta.textContent = 'No se pudo agregar'; setTimeout(refrescar, 1600); });
  });

  /* Se lee el carrito antes de pintar. Si falla, se sigue con el
     comportamiento de siempre: mejor pedir de más que no pintar nada. */
  function leerCarrito(c) {
    if (!c) return;
    enCarrito = typeof c.item_count === 'number' ? c.item_count : enCarrito;
    deCarrito = slotsDesdeCarrito(c);
    refrescar();
    // las tallas no vienen en el carrito: se piden y se repinta al llegar
    cargarTallasDeCarrito();
  }

  /* El carrito solo dice qué variante compraste, no cuáles existen. Para poder
     CAMBIAR la talla desde aquí hay que traer la ficha de cada jersey. Son dos
     peticiones como mucho, y solo cuando hay columnas precargadas. */
  function cargarTallasDeCarrito() {
    var pend = deCarrito.filter(function (d) { return d.handle && !d.tallas; });
    if (!pend.length) return;
    Promise.all(pend.map(function (d) {
      return fetch('/products/' + d.handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var vistas = {}, out = [];
          (p.variants || []).forEach(function (v) {
            if (!v.available) return;
            var et = String(v.title).split('(')[0].split('/')[0].trim() || v.title;
            if (vistas[et]) return;
            vistas[et] = 1;
            out.push({ id: v.id, etiqueta: et });
          });
          d.tallas = out;
        })
        .catch(function () { d.tallas = []; });
    })).then(refrescar);
  }

  /* El carrito avisa cada vez que cambia. Sin esto, el constructor se quedaba
     con la foto del momento en que cargó la página: agregabas dos jerseys y
     seguía pidiendo dos más, aunque el carrito de al lado ya dijera que falta
     uno. Dos partes de la misma promoción contando distinto. */
  /* Tocar la talla o la personalización de algo que YA está en el carrito
     lleva al carrito. Tener el mismo control en dos lugares es como terminan
     los pedidos con la talla equivocada: el cliente la cambia en uno y el otro
     se queda con el valor viejo. */
  raiz.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-abrir-carrito]')) return;
    e.preventDefault();
    if (window.sigmaCart && window.sigmaCart.open) window.sigmaCart.open();
  });

  document.addEventListener('sigma:carrito', function (e) { leerCarrito(e.detail); });

  /* Red de seguridad. El aviso de arriba cubre lo que pasa DENTRO de esta
     página, pero no lo que pasa fuera: otra pestaña, el carrito que caduca, el
     botón atrás del navegador. En esos casos el constructor se quedaba con una
     foto vieja del carrito. Se vuelve a leer al recuperar el foco. */
  var releyendo = false;
  function releerCarrito() {
    if (releyendo || document.hidden) return;
    releyendo = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(leerCarrito)
      .catch(function () {})
      .then(function () { releyendo = false; });
  }
  window.addEventListener('focus', releerCarrito);
  window.addEventListener('pageshow', releerCarrito);
  document.addEventListener('visibilitychange', releerCarrito);

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (c) { enCarrito = c.item_count || 0; deCarrito = slotsDesdeCarrito(c); })
    .catch(function () {})
    .then(function () { refrescar(); });
})();
